import { Box, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useMemo } from 'react';
import Badge from '../Badge/Badge';

const hiddenLessons = ['2', '2.1'];

export default function Pots({ compact }: PotsProps) {
    const game = useGame();
    const page = usePage();

    const { highlightCurrentPot, highlightExpectedPot, showCardValues } = game.lessonProps;

    const expectedPot = useMemo(() => {
        return page.lesson !== '2.2' && page.lesson !== '2.2.1';
    }, [page.lesson]);

    const hide = useMemo(() => {
        return page.lessonParent < 2 || !page.lesson || hiddenLessons.includes(page.lesson);
    }, [page.lesson, page.lessonParent]);

    if (hide) {
        return null;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            justifyContent="center"
            marginLeft={2}
            left="100%"
            position="absolute"
            top={0}
        >
            <Box alignItems="flex-start" display="flex" flexDirection="column" gap={2} justifyContent="center">
                <Box position="relative">
                    <Typography aria-hidden variant="montserrat418">
                        POT
                    </Typography>
                </Box>
                <Badge
                    highlight={highlightCurrentPot}
                    info="currentPot"
                    label="Current"
                    responsive={compact ? 'full' : 'half'}
                    tabIndex={10}
                    title="Current pot"
                    type="currency"
                    value={game.currentPot}
                />
                {expectedPot && (
                    <Badge
                        highlight={highlightExpectedPot}
                        info="expectedPot"
                        label="Expected"
                        responsive={compact ? 'full' : 'half'}
                        tabIndex={11}
                        title="Expected pot"
                        type="currency"
                        value={game.expectedPot}
                    />
                )}
            </Box>
            {showCardValues && (
                <Typography top={112} left={-12} position="absolute" variant="montserrat714">
                    =
                </Typography>
            )}
        </Box>
    );
}
